import React, { useMemo } from "react";
import SelectComp from "../../../../../Reusable/SelectComp";
import { AiOutlineClose } from "react-icons/ai";
import Colors from "../../../../../../assets/Colors";
import { InputComp } from "../../../../../Reusable/InputComp";
import { useDesktopOrLaptop } from "../../../../../../services/useDesktopOrLaptop";
import { useFormikContext } from "formik";
import InputErrorComp from "../../../../../Reusable/InputErrorComp";
import { getFieldValueIcon } from "../utils";

const ExpressionForm = ({
  ruleExpressionFieldsList,
  operationsList,
  equalityOperatorsList,
  removeHandler,
  index,
}) => {
  const { values, errors, touched, handleChange, setFieldValue } =
    useFormikContext();
  const { smFontSize } = useDesktopOrLaptop();

  const styles = useMemo(() => {
    return {
      expressionContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      },
      expressionLeftContainer: {
        width: "40%",
      },
      expressionOperatorContainer: {
        width: "20%",
        margin: "0 20px",
      },
      expressionRightContainer: {
        width: "40%",
      },
      expressionField: {
        marginBottom: "6px",
      },
    };
  }, []);

  const customstyles = {
    selectControl: {
      width: "100%",
      borderWidth: "1px",
      border: `solid ${Colors.inputFieldBorder}`,
      borderRadius: "10px",
      boxShadow: "none",
    },
    selectInput: {
      fontFamily: "Poppins",
      fontSize: smFontSize,
      border: "0px",
      borderRadius: "8px",
      outlineWidth: "0px",
      fontWeight: "500",
      margin: "5px",
    },
  };

  const selectStyles = (isErrors = false) => {
    return {
      control: (styles) => ({
        ...styles,
        ...customstyles.selectControl,
        ...{
          border: isErrors
            ? `solid ${Colors.redDark}`
            : `solid ${Colors.inputFieldBorder}`,
        },
        ":hover": {
          ...styles[":hover"],
          border: isErrors
            ? `solid ${Colors.redDark}`
            : `solid ${Colors.inputFieldBorder}`,
        },
      }),
      input: (styles) => ({
        ...styles,
        ...customstyles.selectInput,
      }),
      options: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
          ":active": {
            ...styles[":active"],
            backgroundColor: !isDisabled
              ? isSelected
                ? Colors.bluePrimary
                : Colors.textColor
              : undefined,
          },
          borderRadius: "10px",
        };
      },
    };
  };

  return (
    <div style={styles.expressionContainer}>
      <div style={styles.expressionLeftContainer}>
        <div style={styles.expressionField}>
          <SelectComp
            selectedValue={ruleExpressionFieldsList.find(
              (item) =>
                item.value ===
                values?.condition?.[index]?.value?.left_side_value?.variable
            )}
            onSelect={(payload) =>
              setFieldValue(
                `condition.${index}.value.left_side_value.variable`,
                payload?.value || null
              )
            }
            optionsList={ruleExpressionFieldsList}
            styleProps={selectStyles(
              touched?.condition?.[index]?.value?.left_side_value?.variable &&
                errors?.condition?.[index]?.value?.left_side_value?.variable
            )}
            useExternalState={true}
          />
          {touched?.condition?.[index]?.value?.left_side_value?.variable && (
            <InputErrorComp
              error={
                errors?.condition?.[index]?.value?.left_side_value?.variable
              }
            />
          )}
        </div>
        <div style={styles.expressionField}>
          <SelectComp
            selectedValue={operationsList.find(
              (item) =>
                item.value ===
                values?.condition?.[index]?.value?.left_side_value?.operation
            )}
            onSelect={(payload) =>
              setFieldValue(
                `condition.${index}.value.left_side_value.operation`,
                payload?.value || null
              )
            }
            optionsList={operationsList}
            styleProps={selectStyles(
              touched?.condition?.[index]?.value?.left_side_value?.operation &&
                errors?.condition?.[index]?.value?.left_side_value?.operation
            )}
            isDisabled={
              !values?.condition?.[index]?.value?.left_side_value?.variable
            }
            resetSelection={
              !values?.condition?.[index]?.value?.left_side_value?.variable
            }
            useExternalState={true}
          />
          {touched?.condition?.[index]?.value?.left_side_value?.operation && (
            <InputErrorComp
              error={
                errors?.condition?.[index]?.value?.left_side_value?.operation
              }
            />
          )}
        </div>
        <InputComp
          name={`condition.${index}.value.left_side_value.field_value`}
          onChange={handleChange}
          value={
            values.condition?.[index]?.value?.left_side_value?.field_value || ""
          }
          disabled={
            !values.condition?.[index]?.value?.left_side_value?.variable
          }
          borderStyles={
            errors?.condition?.[index]?.value?.left_side_value?.field_value &&
            touched?.condition?.[index]?.value?.left_side_value?.field_value
              ? { borderColor: Colors.redDark }
              : {}
          }
          leftIcon={getFieldValueIcon(
            ruleExpressionFieldsList,
            values?.condition?.[index]?.value?.left_side_value?.variable
          )}
        />
        {touched?.condition?.[index]?.value?.left_side_value?.field_value && (
          <InputErrorComp
            error={
              errors?.condition?.[index]?.value?.left_side_value?.field_value
            }
          />
        )}
      </div>
      <div style={styles.expressionOperatorContainer}>
        <SelectComp
          selectedValue={equalityOperatorsList.find(
            (item) =>
              item.value ===
              values?.condition?.[index]?.value?.equality_operator
          )}
          onSelect={(payload) =>
            setFieldValue(
              `condition.${index}.value.equality_operator`,
              payload?.value || null
            )
          }
          optionsList={equalityOperatorsList}
          styleProps={selectStyles(
            touched?.condition?.[index]?.value?.equality_operator &&
              errors?.condition?.[index]?.value?.equality_operator
          )}
          useExternalState={true}
        />
        {touched?.condition?.[index]?.value?.equality_operator && (
          <InputErrorComp
            error={errors?.condition?.[index]?.value?.equality_operator}
          />
        )}
      </div>
      <div style={styles.expressionRightContainer}>
        <div style={styles.expressionField}>
          <SelectComp
            selectedValue={ruleExpressionFieldsList.find(
              (item) =>
                item.value ===
                values?.condition?.[index]?.value?.right_side_value?.variable
            )}
            onSelect={(payload) =>
              setFieldValue(
                `condition.${index}.value.right_side_value.variable`,
                payload?.value || null
              )
            }
            optionsList={ruleExpressionFieldsList}
            styleProps={selectStyles(
              touched?.condition?.[index]?.value?.right_side_value?.variable &&
                errors?.condition?.[index]?.value?.right_side_value?.variable
            )}
            useExternalState={true}
          />
          {touched?.condition?.[index]?.value?.right_side_value?.variable && (
            <InputErrorComp
              error={
                errors?.condition?.[index]?.value?.right_side_value?.variable
              }
            />
          )}
        </div>
        <div style={styles.expressionField}>
          <SelectComp
            selectedValue={operationsList.find(
              (item) =>
                item.value ===
                values?.condition?.[index]?.value?.right_side_value?.operation
            )}
            onSelect={(payload) =>
              setFieldValue(
                `condition.${index}.value.right_side_value.operation`,
                payload?.value || null
              )
            }
            optionsList={operationsList}
            styleProps={selectStyles(
              touched?.condition?.[index]?.value?.right_side_value?.operation &&
                errors?.condition?.[index]?.value?.right_side_value?.operation
            )}
            isDisabled={
              !values?.condition?.[index]?.value?.right_side_value?.variable
            }
            resetSelection={
              !values?.condition?.[index]?.value?.right_side_value?.variable
            }
            useExternalState={true}
          />
          {touched?.condition?.[index]?.value?.right_side_value?.operation && (
            <InputErrorComp
              error={
                errors?.condition?.[index]?.value?.right_side_value?.operation
              }
            />
          )}
        </div>
        <InputComp
          name={`condition.${index}.value.right_side_value.field_value`}
          onChange={handleChange}
          value={
            values?.condition?.[index]?.value?.right_side_value?.field_value ||
            ""
          }
          borderStyles={
            errors?.condition?.[index]?.value?.right_side_value?.field_value &&
            touched?.condition?.[index]?.value?.right_side_value?.field_value
              ? { borderColor: Colors.redDark }
              : {}
          }
          leftIcon={getFieldValueIcon(
            ruleExpressionFieldsList,
            values?.condition?.[index]?.value?.left_side_value?.variable
          )}
        />
        {touched?.condition?.[index]?.value?.right_side_value?.field_value && (
          <InputErrorComp
            error={
              errors?.condition?.[index]?.value?.right_side_value?.field_value
            }
          />
        )}
      </div>
      <div style={{ marginLeft: "10px" }}>
        <AiOutlineClose onClick={removeHandler} />
      </div>
    </div>
  );
};

export default ExpressionForm;
